import { supabase } from './supabaseClient';
import { Property, AIConstructionEstimate, RenovationExpense } from '../types';

// Provider-agnostic AI service.
// In SaaS mode, AI calls MUST go through Supabase Edge Functions so provider keys stay server-side.

export async function analyzePortfolio(properties: Property[], userQuery: string): Promise<string> {
  const { data, error } = await supabase.functions.invoke('ai-analyze-portfolio', {
    body: { properties, userQuery },
  });

  if (error) throw error;
  return (data?.text as string) || 'No response generated.';
}

export async function generateRenovationEstimate(
  propertyType: string,
  location: string,
  areaSqm: number,
  scopeDescription: string
): Promise<AIConstructionEstimate | null> {
  const { data, error } = await supabase.functions.invoke('ai-renovation-estimate', {
    body: { propertyType, location, areaSqm, scopeDescription },
  });

  if (error) throw error;
  return (data?.estimate as AIConstructionEstimate) || null;
}

export async function parseReceiptImage(base64Image: string, mimeType: string): Promise<Partial<RenovationExpense> | null> {
  const { data, error } = await supabase.functions.invoke('ai-parse-receipt', {
    body: { base64Image, mimeType },
  });

  if (error) throw error;
  return (data?.expense as Partial<RenovationExpense>) || null;
}
